import React, { useEffect } from 'react';
import axios from 'axios';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

var FNV1_32A_INIT = 0x811c9dc5;
var API_URL = process.env.REACT_APP_API;
var sendEvent = function sendEvent(kind, payload, experimentMetadata) {
  var chal = 'Chal';
  var lenge = 'lenge';
  var data = JSON.stringify({
    events: [{
      kind: kind,
      payload: payload,
      experimentMetadata: experimentMetadata
    }]
  });

  // always attach challenge header. Backend will determine which
  // events are configured to enforce this integrity checker.
  axios({
    url: "".concat(API_URL, "/v1/events"),
    method: 'POST',
    headers: _defineProperty({
      'Content-Type': 'application/json; charset=UTF-8'
    }, chal + lenge, challengeHeader(data)),
    data: data
  });
};

// compute payload hash, providing basic security-by-obscurity.
// the header will be the FNV-1a has of the following message:
// 'chal'+payload (ascii chars only) +'lenge'
// the backend API will compute the same hash to verify the integrity
// of this message.
function challengeHeader(payload) {
  // Since JS uses UTF-16 strings, we remove all non-ASCII ones,
  // avoiding encoding issues with different langauges.
  var msg = "Uph9CUvOsfC2voqX".concat(payload.replace(
  // eslint-disable-next-line no-control-regex
  /[^\x00-\x7F]/g, ''), "30eGzduOEbD1eDBhEGn48lrjWuHZz2Pz");

  // compute 32 bit FNV-1a hash
  // Ref.: http://isthe.com/chongo/tech/comp/fnv/
  // https://gist.github.com/vaiorabbit/5657561
  var hval = FNV1_32A_INIT;
  for (var i = 0; i < msg.length; ++i) {
    hval ^= msg.charCodeAt(i);
    hval += (hval << 1) + (hval << 4) + (hval << 7) + (hval << 8) + (hval << 24);
  }
  return hval >>> 0;
}

var VIEWPORT_TICKER = 'ViewportTicker';
var OTB_OPENED = 'VotingWorldOpened';
var OTB_CLOSED = 'VotingWorldClosed';
var sendViewportTicker = function sendViewportTicker(trackingData, viewportTicker, experimentMetadata) {
  var payload = _objectSpread2(_objectSpread2({}, trackingData), {}, {
    inViewportSeconds: viewportTicker
  });
  sendEvent(VIEWPORT_TICKER, payload, experimentMetadata);
};
var otbOpened = function otbOpened(trackingData, experimentMetadata) {
  sendEvent(OTB_OPENED, trackingData, experimentMetadata);
};
var otbClosed = function otbClosed(trackingData, experimentMetadata) {
  sendEvent(OTB_CLOSED, trackingData, experimentMetadata);
};

var CAMPAIGN_INTERACTION = 'CampaignInteraction';
var INTERACTION_TYPES = {
  impression: 'impression'
};
var sendCampaignInteraction = function sendCampaignInteraction(trackingData, interactionType, experimentMetadata) {
  var payload = _objectSpread2(_objectSpread2({}, trackingData), {}, {
    interaction: interactionType
  });
  sendEvent(CAMPAIGN_INTERACTION, payload, experimentMetadata);
};

var TrackingOTB = function TrackingOTB(_ref) {
  var trackingData = _ref.trackingData,
    experimentMetadata = _ref.experimentMetadata;
  // track opening voting world
  useEffect(function () {
    otbOpened(trackingData, experimentMetadata);
  }, [trackingData, experimentMetadata]);

  // send campaign interaction event
  useEffect(function () {
    sendCampaignInteraction(trackingData, INTERACTION_TYPES.impression, experimentMetadata);
  }, [trackingData, experimentMetadata]);

  // track time spend on voting world
  useEffect(function () {
    var timeOpen = 0;
    var userRetention = function userRetention(timeOpened) {
      var seconds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      setInterval(function () {
        timeOpened = parseFloat(timeOpened + seconds);
        timeOpen = timeOpened;
      }, seconds * 1000);
      sendViewportTicker(trackingData, timeOpened, experimentMetadata);
      var intervalId = setInterval(function () {
        sendViewportTicker(trackingData, timeOpened, experimentMetadata);
      }, seconds * 1000);
      return intervalId;
    };

    // track every second
    var timerId = userRetention(timeOpen, 1);
    // until 1 minute
    setTimeout(function () {
      clearInterval(timerId);
      // than track only every 10s
      var slowTimerId = userRetention(timeOpen, 10);

      //for 10 more minutes and stop
      setTimeout(function () {
        clearInterval(slowTimerId);
      }, 60 * 10 * 1000);
    }, 60 * 1000);
  }, [trackingData, experimentMetadata]);
  return null;
};

/**
 * poor mans template strings. works for our use cases.
 *
 * can replace 'pi is [something]' with context `{ something: 3.14 }` to 'pi
 * is 3.14'
 */
function processTemplate(str) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return Object.keys(context).reduce(function (parsedText, key) {
    return parsedText.replace("[".concat(key, "]"), context[key]);
  }, str);
}

var DEFAULT_MACROS_MAPER = {
  isGdprApplies: /\$\{GDPR(\}|_APPLIES\})/,
  gdprConsent: /\$\{GDPR_CONSENT_([0-9]{1,}|STRING)\}/,
  refererUrl: /\$\{REFERER_URL_ENC\}/
};
var cashedMacrosValues = {};
var extendCashedMacrosValues = function extendCashedMacrosValues(key, value) {
  if (!key || !value) return cashedMacrosValues;
  cashedMacrosValues = _objectSpread2(_objectSpread2({}, cashedMacrosValues), {}, _defineProperty({}, key, value));
};

// cashedReplacementMacrosMap is only default value, it can be removed when replacementMacrosMap is passed to function
var replaceMacros = function replaceMacros() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var macrosValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : cashedMacrosValues;
  var macrosMap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_MACROS_MAPER;
  if (!url || !macrosValues) return url;
  return Object.keys(macrosValues).reduce(function (parsedText, key) {
    var checker = macrosMap[key];
    var value = macrosValues[key].toString();
    return value ? parsedText.replace(checker, value) : parsedText;
  }, url);
};

/**
 * Tracking is a component to inject tracking pixels into our application.
 *
 * The use case here is to allow third party providers to track our tools with
 * their own infrastructure. Most of the time this will be an <img /> pixel.
 */
var TrackingPixel = /*#__PURE__*/function (_React$Component) {
  _inherits(TrackingPixel, _React$Component);
  var _super = _createSuper(TrackingPixel);
  function TrackingPixel() {
    _classCallCheck(this, TrackingPixel);
    return _super.apply(this, arguments);
  }
  _createClass(TrackingPixel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        rendered: true
      });
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(next, state) {
      // we have to be careful to not rerender.
      return !state.rendered;
    }
  }, {
    key: "render",
    value: function render() {
      var rawHtml = this.props.rawHtml;

      // Default context we provide to our pixel.
      // Allows us to interpolate known variables in the input HTML to add e.g.
      // timestamps.
      var context = {
        timestamp: Date.now(),
        TIMESTAMP: Date.now()
      };
      var interpolated = processTemplate(replaceMacros(rawHtml), context);
      return /*#__PURE__*/React.createElement("span", {
        style: {
          display: 'none'
        },
        dangerouslySetInnerHTML: {
          __html: interpolated
        }
      });
    }
  }]);
  return TrackingPixel;
}(React.Component);

var generateTrackingPixelImage = function generateTrackingPixelImage(url) {
  if (!url) return;
  var image = new Image();
  image.src = replaceMacros(url);
  return image;
};

/**
 * newID creates a user ID.
 *
 * 2 chars - version ID
 * 8 chars - creation time in UNIX seconds, serialized as hex encoded int32
 * 16 chars - of random data
 * @return {string} - user id format: v1-<creation time>-<random data>
 */
var createNewUserId = function createNewUserId() {
  var t = Math.floor(new Date().getTime() / 1000).toString(16);
  return "v1-".concat(t).concat('-xxxxxxxxxxxxxxxx'.replace(/[x]/g, function () {
    return (Math.random() * 16 | 0).toString(16);
  }));
};

export { DEFAULT_MACROS_MAPER, TrackingOTB, TrackingPixel, createNewUserId, extendCashedMacrosValues, generateTrackingPixelImage, otbClosed, otbOpened, replaceMacros, sendCampaignInteraction, sendViewportTicker };
